import { useEffect, useState } from 'react';

const defaultSettings = {
  enableHighAccuracy: true,
  timeout: Infinity,
  maximumAge: 0
};

export default function useGeoLocation({
  accessDeviceLocation = false,
  watch = false,
  settings = defaultSettings
}) {
  const [position, setPosition] = useState({});
  const [error, setError] = useState(null);

  const onChange = ({ coords, timestamp }) => {
    setPosition({
      latitude: coords.latitude,
      longitude: coords.longitude,
      timestamp
      // how accurate the device coordinates are
      // accuracy: coords.accuracy,
    });
  };

  const onError = e => {
    setError(e.message);
  };

  useEffect(() => {
    if (!accessDeviceLocation) {
      return;
    }

    if (!navigator || !navigator.geolocation) {
      setError('Geolocation is not supported');

      return;
    }

    let watcher = null;

    if (watch) {
      watcher = navigator.geolocation.watchPosition(
        onChange,
        onError,
        settings
      );
    } else {
      navigator.geolocation.getCurrentPosition(onChange, onError, settings);
    }

    return () => watcher && navigator.geolocation.clearWatch(watcher);
  }, [settings, watch, accessDeviceLocation]);

  return { ...position, error };
}
